var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"badge-display"},[_vm._t("default"),_vm._v(" "),(_vm.isFlagship)?_c('flagship-badge'):_vm._e(),_vm._v(" "),(_vm.babysit)?_c('babysit-badge'):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }